
import React from 'react'
import DomainContextWrapper from './DomainContext'
import PrivilegesContextWrapper from './PrivilegesContext'

const ContextWrapper = ({ children }) =>
    <>
        <DomainContextWrapper>
            <PrivilegesContextWrapper>
                {children}
            </PrivilegesContextWrapper>
        </DomainContextWrapper>
    </>



export default ContextWrapper   